import dynamic from 'next/dynamic';
import {createTranslator, type AbstractIntlMessages} from 'next-intl';
import withMainLayout from 'layouts/main';
import {pageMessagesProps} from 'helpers/i18n';
import CustomersHero from '@/content/customers/hero';
import shared from '../messages/en/shared.json';
import customers from '../messages/en/customers.json';
import homepage from '../messages/en/homepage.json';


const StatsSection = dynamic(() => import('@/content/customers/stats-section'), {
  loading: () => null
});

const TestimonialsSection = dynamic(() => import('@/content/customers/testimonials-section'), {
  loading: () => null
});

const StoriesSection = dynamic(() => import('@/content/customers/stories-section'), {
  loading: () => null
});

const CompanyLogoSection = dynamic(() => import('@/content/customers/company-logo-section'), {
  loading: () => null
});

const RecognisedSection = dynamic(() => import('@/content/customers/recognised-section'), {
  loading: () => null
});

const SingleTestimonial = dynamic(() => import('@/content/customers/single-testimonial'), {
  loading: () => null
});

const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const CustomersPage = () => (
  <>
    <CustomersHero />
    <CompanyLogoSection />
    <TestimonialsSection fillMedia />
    <StatsSection />
    <SingleTestimonial />
    <StoriesSection />
    <RecognisedSection />
    <PreFooter />
  </>
);

type PageMessagesProps = {
  locale: string;
  messages: AbstractIntlMessages;
};

const seoMetas = (props: PageMessagesProps) => {
  const t = createTranslator({
    locale: props.locale,
    messages: props.messages
  }) as (key: string) => string;

  return {
    title: t('customers.seo.title'),
    description: t('customers.seo.description'),
    canonical: t('customers.seo.canonical')
  };
};

export const messagesForIntl = {shared, customers, homepage};

export function getStaticProps() {
  return pageMessagesProps(messagesForIntl);
}

export default withMainLayout(CustomersPage, seoMetas as never);
